import { create } from "zustand";
import { immer } from "zustand/middleware/immer";
import type { ModulePermission } from "../constants/permissions";

type AuthState = {
  isFreyrAdmin: boolean;
  isHistory: boolean;
  isPayloads: boolean;
  isTasks: boolean;
  isTemplates: boolean;
  canAddTemplates: boolean;
  canEditTemplates: boolean;
  canDeleteTemplates: boolean;
  columnHide: boolean;
};

type AuthActions = {
  syncPermissions: (module: ModulePermission) => void;
  updateIsFreyrAdmin: (isFreyrAdmin: boolean) => void;
  updateIsHistory: (isHistory: boolean) => void;
  updateIsPayloads: (isPayloads: boolean) => void;
  updateIsTasks: (isTasks: boolean) => void;
  updateIsTemplates: (isTemplates: boolean) => void;
  updateColumnHide: (columnHide: boolean) => void;
};

export const useAuthStore = create<AuthState & AuthActions>()(
  immer((set) => ({
    isFreyrAdmin: false,
    isHistory: false,
    isPayloads: false,
    isTasks: false,
    isTemplates: false,
    canAddTemplates: false,
    canEditTemplates: false,
    canDeleteTemplates: false,
    columnHide: false,

    syncPermissions(module) {
      set((state) => {
        state.isHistory = module.isHistory;
        state.isPayloads = module.isPayloads;
        state.isTasks = module.isTasks;
        state.isTemplates = module.templates.canView;
        state.canAddTemplates = module.templates.canAdd;
        state.canEditTemplates = module.templates.canEdit;
        state.canDeleteTemplates = module.templates.canDelete;
      });
    },
    updateIsFreyrAdmin(val) {
      set((state) => {
        state.isFreyrAdmin = val;
      });
    },
    updateIsHistory(val) {
      set((state) => {
        state.isHistory = val;
      });
    },
    updateIsPayloads(val) {
      set((state) => {
        state.isPayloads = val;
      });
    },
    updateIsTasks(val) {
      set((state) => {
        state.isTasks = val;
      });
    },
    updateIsTemplates(val) {
      set((state) => {
        state.isTemplates = val;
      });
    },
    updateColumnHide(val) {
      set((state) => {
        state.columnHide = val;
      });
    },
  }))
);
